import { NgModule } from '@angular/core';
import {  MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { PurchaseHistoryPipeModule, FormatUrlPipeModule } from '../../../pipes';
import { ContactOverviewIconsComponent } from './contact-overview-icons.component';
import { BestPhoneTypePipe } from './pipes';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    declarations: [
        ContactOverviewIconsComponent,
        BestPhoneTypePipe,
    ],
    exports: [ContactOverviewIconsComponent],
    imports: [
        DisableAutocompleteDirectiveModule,
        FormatUrlPipeModule,
        MatTooltipModule,
        CommonModule,
        PurchaseHistoryPipeModule,
        FontAwesomeModule,
    ]
})
export class ContactOverviewIconsModule {}
